"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidationSchema = exports.getJSONValidationSchema = void 0;

var _lodash = require("lodash");

var yup = _interopRequireWildcard(require("yup"));

var _apiService = _interopRequireDefault(require("../../../utils/api-service"));

var _commonConstants = require("../../../utils/common-constants");

var _utils = require("../utils");

var _commonUtils = require("../../../utils/common-utils");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var allContextField = 'all';
var nameContextField = 'name';
var policyNameTest = 'Policy name';

var getJSONValidationSchema = function getJSONValidationSchema() {
  return yup.object({
    JSONInputData: yup.string().min(1, _constants.translatedStrings.policyJSONValidation).required(_constants.translatedStrings.policyJSONValidation).test('JSONInputData', _constants.translatedStrings.invalidJson, function (value) {
      try {
        if ((0, _lodash.isEmpty)(value)) {
          return true;
        }

        JSON.parse(value);
        return true;
      } catch (error) {
        return false;
      }
    })
  });
};

exports.getJSONValidationSchema = getJSONValidationSchema;

var getValidationSchema = function getValidationSchema(setPolicyFilterLoading, editPolicy, openNotification, consumerEntityId) {
  return yup.object({
    name: yup.string().trim().required(_constants.translatedStrings.policyNameValidation).max(_commonConstants.maxPolicyNameCharLimit, _constants.translatedStrings.inputNameMaxCharsValidation).test(policyNameTest, _constants.translatedStrings.policyNameCharacterValidation, _commonUtils.nameCharacterValidation).test(policyNameTest, _constants.translatedStrings.policyUniqueNameValidation, /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value, context) {
        var _context$options;

        var contextField, endpoint, response, _response$data, _response, _response$data2, reason;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(value.length > _commonConstants.maxPolicyNameCharLimit || !(0, _commonUtils.nameCharacterValidation)(value))) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", true);

              case 2:
                contextField = context === null || context === void 0 ? void 0 : (_context$options = context.options) === null || _context$options === void 0 ? void 0 : _context$options.context;

                if (!((contextField === nameContextField || contextField === allContextField) && value !== '')) {
                  _context.next = 26;
                  break;
                }

                setPolicyFilterLoading(true);
                _context.prev = 5;

                if ((0, _utils.isAccessBuilderPath)()) {
                  endpoint = "/api/profile-requests/paps/".concat(consumerEntityId, "/policies/").concat(value);
                } else if ((0, _utils.isResourcePolicyPath)()) {
                  endpoint = "/api/resource-manager/policies/".concat(value);
                } else if ((0, _utils.isServerAccessPath)()) {
                  endpoint = "/api/resource-manager/profiles/".concat(consumerEntityId, "/policies/").concat(value);
                } else {
                  endpoint = "/api/paps/".concat(consumerEntityId, "/policies/").concat(value);
                }

                _context.next = 9;
                return _apiService.default.get(endpoint);

              case 9:
                response = _context.sent;
                setPolicyFilterLoading(false);
                return _context.abrupt("return", editPolicy && response.data.id === editPolicy.id ? true : false);

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](5);
                _response = _context.t0.response;
                setPolicyFilterLoading(false);

                if (!((_response === null || _response === void 0 ? void 0 : (_response$data = _response.data) === null || _response$data === void 0 ? void 0 : _response$data.errorCode) === "PP-0005")) {
                  _context.next = 22;
                  break;
                }

                return _context.abrupt("return", true);

              case 22:
                reason = (_response === null || _response === void 0 ? void 0 : (_response$data2 = _response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.message) || '';
                openNotification(_commonConstants.errorNotificationType, reason, _constants.errorNotificationTime);

              case 24:
                _context.next = 27;
                break;

              case 26:
                return _context.abrupt("return", true);

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 14]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()),
    description: yup.string().max(255, _constants.translatedStrings.descriptionMaxCharValidation),
    allUser: yup.boolean(),
    allServiceIdentity: yup.boolean(),
    allToken: yup.boolean(),
    allGroup: yup.boolean(),
    isIpAddress: yup.boolean(),
    ipAddress: yup.string().when('isIpAddress', {
      is: true,
      then: yup.string().required(_constants.translatedStrings.ipAddrValidation).test('ipAddress', _constants.translatedStrings.ipAddressInvalidMsg, function (value) {
        return !value || !value.trim() ? true : value.split(',').find(function (ip) {
          return !ip.trim().match(_constants.ipNewRegex);
        }) === undefined;
      }),
      otherwise: yup.string().nullable().default(null)
    }),
    isDateTime: yup.boolean().test('isDateTime', _constants.translatedStrings.timeValidation, function (value) {
      return !value || this.parent.dateSchedule || this.parent.daysSchedule;
    }),
    dateSchedule: yup.boolean(),
    daysSchedule: yup.boolean(),
    startDate: yup.date().when('dateSchedule', {
      is: true,
      then: yup.date().required(_constants.translatedStrings.startDateTimeValidation).typeError(_constants.translatedStrings.startDateTimeValidation).test('startDate', _constants.translatedStrings.startDateTimeMessage, function (value) {
        var startDate = value;
        var endDate = this.parent.endDate;

        if ((startDate === null || startDate === void 0 ? void 0 : startDate.getTime()) >= (endDate === null || endDate === void 0 ? void 0 : endDate.getTime())) {
          return false;
        }

        if ((startDate === null || startDate === void 0 ? void 0 : startDate.getTime()) > new Date().getTime() || !(0, _lodash.isEmpty)(editPolicy)) {
          return true;
        }

        return false;
      }),
      otherwise: yup.date().nullable().default(null)
    }),
    endDate: yup.date().when('dateSchedule', {
      is: true,
      then: yup.date().required(_constants.translatedStrings.endDateTimeValidation).typeError(_constants.translatedStrings.endDateTimeValidation).test('endDate', _constants.translatedStrings.endDateTimeValidationMsg, function (value, context) {
        var startDate = this.parent.startDate;
        var endDate = value;

        if ((startDate === null || startDate === void 0 ? void 0 : startDate.getTime()) >= (endDate === null || endDate === void 0 ? void 0 : endDate.getTime())) {
          return false;
        }

        if ((endDate === null || endDate === void 0 ? void 0 : endDate.getTime()) < new Date().getTime()) {
          return context.createError({
            path: context.path,
            message: _constants.translatedStrings.endDateShouldGreaterThanTodayValidationMsg
          });
        }

        return true;
      }),
      otherwise: yup.date().nullable().default(null)
    }),
    startTime: yup.date().when('daysSchedule', {
      is: true,
      then: yup.date().required(_constants.translatedStrings.startTimeValidation).typeError(_constants.translatedStrings.startTimeValidation).test('startTime', _constants.translatedStrings.startTimeValidation, function () {
        return !!this.parent.endTime;
      }),
      otherwise: yup.date().nullable().default(null)
    }),
    selectedDays: yup.array().when('daysSchedule', {
      is: true,
      then: yup.array().test('selectedDays', _constants.translatedStrings.selectedDaysValidation, function (value) {
        return value.length > 0;
      }),
      otherwise: yup.array().nullable().default([])
    }),
    timezone: yup.object().nullable().test('timezone', _constants.translatedStrings.timezoneValidation, function (value) {
      return !((0, _lodash.isEmpty)(value) && (this.parent.dateSchedule || this.parent.daysSchedule));
    }),
    isApprovals: yup.boolean(),
    notificationMedium: yup.array().when('isApprovals', {
      is: true,
      then: yup.array().test('notificationMedium', _constants.translatedStrings.notifMediumValidation, function (value) {
        var notificationMedium = !(0, _lodash.isEmpty)(value);
        return notificationMedium;
      }),
      otherwise: yup.array().nullable(true)
    }),
    approvalMaxTime: yup.string().when('isApprovals', {
      is: true,
      then: yup.string().required(_constants.translatedStrings.maxApprovalTimeValidation).test('approvalMaxTime', _constants.translatedStrings.maxApprovalFormatValidation, function (value) {
        if ((0, _lodash.isEmpty)(value)) {
          return true;
        }

        if (!value.includes(_commonConstants.COLON_SEPARATOR)) {
          return false;
        }

        var _value$split$map = value.split(_commonConstants.COLON_SEPARATOR).map(function (data) {
          return data.length > 0 ? Number(data) : -1;
        }),
            _value$split$map2 = _slicedToArray(_value$split$map, 2),
            hours = _value$split$map2[0],
            minutes = _value$split$map2[1];

        var isTimeValid = isNaN(hours) || isNaN(minutes) || hours < 0 || minutes < 0 || minutes > 59 || !(0, _utils.getMinutesFromHMTime)(value);
        return !isTimeValid;
      })
    }),
    validFor: yup.string().when('isApprovals', {
      is: true,
      then: yup.string().test('validFor', _constants.translatedStrings.maxTimeAfterApprovaltValidation, function (value, context) {
        var isValidForInDays = context.parent.isValidForInDays;

        if (isValidForInDays && (0, _lodash.isEmpty)(value)) {
          return true;
        } else if (!isValidForInDays && (0, _lodash.isEmpty)(value)) {
          return false;
        } else if (value && !value.includes(_commonConstants.COLON_SEPARATOR)) {
          return false;
        }

        var _value$split$map3 = value.split(_commonConstants.COLON_SEPARATOR).map(function (data) {
          return data.length > 0 ? Number(data) : -1;
        }),
            _value$split$map4 = _slicedToArray(_value$split$map3, 2),
            hours = _value$split$map4[0],
            minutes = _value$split$map4[1];

        var isTimeValid = isNaN(hours) || isNaN(minutes) || hours < 0 || minutes < 0 || minutes > 59 || !(0, _utils.getMinutesFromHMTime)(value);
        return !isTimeValid;
      })
    }),
    validForDays: yup.string().when('isApprovals', {
      is: true,
      then: yup.string().test('validForDays', _constants.translatedStrings.minApprovalDays, function (value, context) {
        var isValidForInDays = context.parent.isValidForInDays;
        if (!isValidForInDays) return true;

        if (value && Number(value) > 0) {
          return true;
        } else {
          return false;
        }
      })
    }),
    isReadOnly: yup.boolean(),
    isActive: yup.boolean(),
    isDraft: yup.boolean(),
    isChannelsRequired: yup.boolean(),
    tagList: yup.array().when('isApprovals', {
      is: true,
      then: yup.array().test('tagList', _constants.translatedStrings.groupsValidation, function (value, context) {
        var _context$parent;

        // Skip validation if Manager Only is selected
        if (((_context$parent = context.parent) === null || _context$parent === void 0 ? void 0 : _context$parent.condition) === 'Manager') return true;
        var userList = !(0, _lodash.isEmpty)(context.parent.userList);
        var tagList = !(0, _lodash.isEmpty)(value);
        return tagList || userList;
      }),
      otherwise: yup.array().nullable(true)
    }),
    channelList: yup.array().nullable().notRequired(),
    slackAppChannels: yup.array().nullable().notRequired(),
    userList: yup.array().when('isApprovals', {
      is: true,
      then: yup.array().test('userList', _constants.translatedStrings.usersValidation, function (value, context) {
        var _context$parent2;

        // Skip validation if Manager Only is selected
        if (((_context$parent2 = context.parent) === null || _context$parent2 === void 0 ? void 0 : _context$parent2.condition) === 'Manager') return true;
        var userList = !(0, _lodash.isEmpty)(value);
        var tagList = !(0, _lodash.isEmpty)(context.parent.tagList);
        return tagList || userList;
      }),
      otherwise: yup.array().nullable(true)
    }),
    stepUpVerificationEnabled: yup.boolean(),
    stepUpVerificationAlwaysPrompt: yup.boolean()
  });
};

exports.getValidationSchema = getValidationSchema;